import Script from "next/script";
import { captureMessage } from "@sentry/nextjs";
import { logger } from "@portal/app/_common/lib/logger";

export const GoogleAuthScript = ({ onReady }: { onReady?: () => void | null }) => (
  <Script
    src="https://accounts.google.com/gsi/client"
    async
    defer
    onReady={() => {
      if (!process.env.GOOGLE_OAUTH_CLIENT_ID) {
        captureMessage(`Missing GOOGLE_OAUTH_CLIENT_ID`, "error");
        logger.error(`process.env.GOOGLE_OAUTH_CLIENT_ID`);
        return;
      }
      return onReady?.();
    }}
  />
);
